var _defs, _defs2, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPandora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "pandora__a",
    fill: "#fff",
    d: "M0 0h32v32H0z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pandora__d",
    x1: 5.319,
    x2: 22.327,
    y1: 21.478,
    y2: 7.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0090F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "pandora__b"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pandora__a"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pandora__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pandora__c",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pandora__c)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#pandora__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#pandora__d)",
    d: "M17.512 6.333H8.833v19.334h5.189a.873.873 0 0 0 .872-.873v-3.712h1.3c6.348 0 8.947-3.574 8.947-7.76-.01-5.17-3.935-6.989-7.63-6.989Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandora);
export default __webpack_public_path__ + "static/media/pandora.e56c629d2a3cc558933c7b60526bc39d.svg";
export { ForwardRef as ReactComponent };